<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t("viewSettings.shop_payment_details.title") }}</h3>
    <v-card
      class="mt-2"
      elevation="0"
      :loading="!fetched || savingInProgress"
    >
      <v-row>
        <v-col cols="12" lg="6">
          <v-form ref="generalParamsForm">
            <v-text-field
              :disabled="!fetched || savingInProgress"
              v-model="shopTemp.bank"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              :value="shopTemp.bank"
              :label="$t('viewSettings.shop_payment_details.bank')"
              outlined
            ></v-text-field>
            <v-text-field
              :disabled="!fetched || savingInProgress"
              v-model="shopTemp.bank_location"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              :value="shopTemp.bank_location"
              :label="$t('viewSettings.shop_payment_details.bank_location')"
              outlined
            ></v-text-field>


            <v-text-field
              :disabled="!fetched || savingInProgress"
              v-model="shopTemp.rasch_schet"
              :value="shopTemp.rasch_schet"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              :label="$t('viewSettings.shop_payment_details.rasch_schet')"
              outlined
            ></v-text-field>
            <v-text-field
              v-if="isVisibleRussianRequisites"
              :disabled="!fetched || savingInProgress"
              v-model="shopTemp.bik"
              :value="shopTemp.bik"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              :label="$t('viewSettings.shop_payment_details.bik')"
              outlined
            ></v-text-field>

            <v-text-field
              :disabled="!fetched || savingInProgress"
              v-model="shopTemp.korr_schet"
              :value="shopTemp.korr_schet"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              :label="$t('viewSettings.shop_payment_details.korr_schet')"
              outlined
            ></v-text-field>
            <v-divider></v-divider>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="savingInProgress"
              :loading="savingInProgress"
              class="mt-5 white--text mr-4"
              elevation="0"
              color="red"
              @click="fillShopTemp"
              @keyup.enter="fillShopTemp"
            >
              {{ $t("common.cancel") }}
            </v-btn>
            <v-btn
              :disabled="savingInProgress"
              :loading="savingInProgress"
              class="mt-5"
              color="primary"
              elevation="0"
              @click="submit"
              @keyup.enter="submit"
            >
              {{ $t("common.save") }}
            </v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    shopTemp: {
      bank: null, //Название банка
      bank_location: null, //Местонахождения банка
      rasch_schet: null, //Расчетный счет
      bik: null, //БИК
      korr_schet: null, //Корр.счет
    },
  }),
  created() {
    this.$store.dispatch("shop_payment_details/get");
    this.fillShopTemp();
  },
  computed: {
    ...mapState("auth", ["authenticatedUser", "isFetching"]),
    ...mapState("shop_payment_details", [
      "shopPaymentDetails",
      "savingInProgress",
      "fetched",
    ]),
    isVisibleRussianRequisites(){
      return this.lang === 'ru';
    }
  },
  watch: {
    fetched() {
      this.fillShopTemp();
    },
  },
  methods: {
    submit() {
      if (this.$refs["generalParamsForm"].validate()) {
        this.$store.dispatch("shop_payment_details/update", this.shopTemp);
      }
    },
    fillShopTemp() {
      this.shopTemp.bank = this.shopPaymentDetails.bank;
      this.shopTemp.bank_location = this.shopPaymentDetails.bank_location;
      this.shopTemp.rasch_schet = this.shopPaymentDetails.rasch_schet;
      this.shopTemp.bik = this.shopPaymentDetails.bik;
      this.shopTemp.korr_schet = this.shopPaymentDetails.korr_schet;
    },
  },
};
</script>

<style scoped></style>
